import React from 'react';
import ChatBox, {ChatType} from './ChatBox';
import ChatInput from './ChatInput';

type EditableChatProps = {
  chat: ChatType;
  boxBg: string;
  circleBg: string;
  onSave: (updatedText: string, chat: ChatType) => void;
  onDelete: (chat: ChatType) => void;
  startInEditMode?: boolean;
};

const EditableChat: React.FC<EditableChatProps> = ({
  chat,
  boxBg,
  circleBg,
  onSave,
  onDelete,
  startInEditMode = false,
}) => {
  const [isEditing, setIsEditing] = React.useState(startInEditMode);
  const [value, setValue] = React.useState(chat.comment);

  const user = localStorage.getItem('user');
  const isMe = (commentedBy: string) =>
    user ? JSON.parse(user)?._id === commentedBy : false;

  React.useEffect(() => {
    setValue(chat.comment);
  }, [chat.comment]);

  const handleBoxClick = () => {
    if (!isEditing && isMe(chat?.commentBy?._id)) {
      setIsEditing(true);
    }
  };

  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = e => {
    setValue(e.target.value);
  };

  const handleTick = () => {
    const trimmed = value.trim();
    if (trimmed === '') return;
    onSave(trimmed, chat);
    setIsEditing(false);
  };

  const handleDelete = () => {
    onDelete(chat);
  };

  if (!isEditing) {
    return (
      <ChatBox
        chat={chat}
        boxBg={boxBg}
        circleBg={circleBg}
        onBoxClick={handleBoxClick}
      />
    );
  }

  return (
    <ChatInput
      chat={chat}
      value={value}
      onChange={handleChange}
      onTickClick={handleTick}
      onDeleteClick={handleDelete}
    />
  );
};

export default EditableChat;
